const checkIfSafari = () => {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};

const activateImageFallback = () => {
  const patternProducts = document.querySelectorAll(".pattern-product");

  console.log(!(window.innerWidth <= 768));

  if (!patternProducts.length || !(window.innerWidth <= 768)) return false;

  patternProducts.forEach((pattern) => {
    const mobileFallback = pattern.querySelector(".mobile-fallback");
    const videoElement = pattern.querySelector("video");

    if (mobileFallback) {
      if (videoElement) videoElement.style.display = "none";

      mobileFallback.classList.remove("hidden");
    }
  });
};

const switchVideoSource = () => {
  const isMobile = activateImageFallback();

  if (isMobile || checkIfSafari()) return;

  const videoElements = document.querySelectorAll("video");

  videoElements.forEach((video) => {
    const webmSource = video.querySelector('source[type="video/webm"]');

    if (webmSource) {
      video.src = webmSource.src;
      video.load();
    }
  });
};

export default switchVideoSource;
